<div style="width: 100%; height: 100%">
  <div class="row-layout justify-content-stretch" style="height: 100%">
    <div style="min-width: 320px; width: 60%; height: 100%">
      <app-orders-grid #grid [filter]="false"></app-orders-grid>
    </div>
    <div style="margin-left: 1rem; padding: 2rem 1rem 0 1rem; width: 12.5rem">
      <button
        mat-raised-button
        style="padding: 0.4rem; height: auto"
        class="full-size-button grey-on-hover"
        (click)="addTeam()"
      >
        <mat-icon
          style="
          line-height: 1.5rem;
            margin-left: 0.5rem;
            font-size: 1.5rem;
            width: 2rem;
            height: 1.5rem;
          "
          >person_add</mat-icon
        >
        <span style="padding: 0.4rem">Neues Team anlegen</span>
      </button>
    </div>
  </div>
</div>
